export const AUDIENCE_SORT_TYPES = ['top', 'earliest'] as const;
export type AudienceSortType = (typeof AUDIENCE_SORT_TYPES)[number];

export const FIRST_ROW = 4;
export const SECOND_ROW = FIRST_ROW + 6;
export const THIRD_ROW = SECOND_ROW + 7;
export const FOURTH_ROW = THIRD_ROW + 8;

export const HIGHLIGHTED = {
  WHALE: {
    icon: '/images/audience-whale-badge.png',
    long_title: 'The Whale',
    short_title: 'Whale',
    long_description: 'Be the top spender',
    short_descrition: 'Highest spender',
  },
  RECENT: {
    icon: '/images/audience-recent-badge.png',
    long_title: 'Recent Collector',
    short_title: 'Recent',
    long_description: 'Be a recent collector',
    short_descrition: 'Latest collector',
  },
  EARLIEST: {
    icon: '/images/audience-earliest-badge.png',
    long_title: 'Earliest Collector',
    short_title: 'Earliest',
    long_description: 'Be the first to collect',
    short_descrition: 'First collector',
  },
} as const;
